import React, {Component} from 'react'
import {Route} from 'react-router-dom'
import routes from '../routes'

import {Container} from 'reactstrap'
import Header from '../components/Header/Header'
import Sidebar from '../components/Sidebar/Sidebar'
import Breadcrumbs from '../components/Breadcrumb/Breadcrumbs'
import Footer from '../components/Footer/Footer'
import Aside from '../components/Aside/Aside'
import NotAuthorizedAlert from '../components/Alerts/NotAuthorizedAlert'
// import GoogleAnalytics from '../components/Support/GoogleAnalytics'

class App extends Component {
  constructor(props) {
    super(props)
    this.state = {
      asideIsOpen: document.body.classList.value.indexOf('aside-menu-hidden') === -1,
      notifyCount: 0
    }

    this.assideToggle = this.assideToggle.bind(this)
    this.onNotifyCountChange = this.onNotifyCountChange.bind(this)
  }

  componentDidMount() {
    window.addEventListener('changeNotifyCountInApp', this.onNotifyCountChange)
  }

  componentWillUnmount() {
    window.removeEventListener('changeNotifyCountInApp', this.onNotifyCountChange)
  }

  onNotifyCountChange(e) {
    if (e.detail.notifyCount !== this.state.notifyCount) {
      this.setState({notifyCount: e.detail.notifyCount})
    }
  }

  assideToggle() {
    this.setState({asideIsOpen: !this.state.asideIsOpen})
  }

  render() {
    return (
      <div className="app">
        <NotAuthorizedAlert/>
        {/* <Route path="/:path" component={GoogleAnalytics}/> */}
        <Header onAsideToggle={this.assideToggle} notifyCount={this.state.notifyCount}/>
        <div className="app-body">
          <Sidebar/>
          <main className="main">
            <Route path="/:path" component={Breadcrumbs}/>
            <Container fluid>
              {routes}
            </Container>
          </main>
          <Aside asideIsOpen={this.state.asideIsOpen} notifyCount={this.state.notifyCount}/>
        </div>
        <Footer/>
      </div>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/containers/App.js